import { findPageHead } from "../presentation/find-page-head";
import { findBeforeLoad, findLoader, findLoaderDeps } from "./find-route";
import { FindSearchSchema } from "./find-route.contract.ts";

export const browseDogsHomeRoute = {
    validateSearch: FindSearchSchema,
    loaderDeps: findLoaderDeps,
    beforeLoad: findBeforeLoad,
    loader: findLoader,
    head: () => findPageHead("/"),
};
